const TKO_PRIMORYE_HOST = 'tko.primorye.moy-gorod.su';
export const WASTE_VERTICAL_ROUTE = '/tickets';

export const isWasteVerticalHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase() === TKO_PRIMORYE_HOST;
};
